import { render } from "./create-group-modal.vue?vue&type=template&id=1cbca7e9"
import script from "./create-group-modal.vue?vue&type=script&lang=js"
export * from "./create-group-modal.vue?vue&type=script&lang=js"
script.render = render

export default script